import { Tour } from '@/_models/Tour';

export type FlowbarProps = {
  flow: any;
  flows: any[];
  selectedFlow: any;
  handleCloseFlowbar: () => Promise<unknown>;
  moveToSweep: any;
  hideElements: any;
  showElements: any;
  showCaseTemp: any;
  showcase: any;
  tags: any;
  setFlows: any;
  polygons: any;
  vsObjects: any;
  navigationManager: any;
  allSweeps: any;
  currentFloor: any;
  isSwitchDialogOpen: boolean;
  handleSwitchAgree: (flow: any) => void;
  closeSwitchDialog: (_: any, preventEmit: boolean) => void;
  flowsVisibleAssets: any;
  flowsBarMeshComponent: any;
  flowsMenuMeshComponent: any;
  vrEventManager: any;
  tour: Tour;
  handleEmitActionBySocket: (actionName: string, data?: any) => void;
  socket: any;
  isLocked: boolean;
  isRemoteControlled: boolean;
};

export enum TFlowFinishCondition {
  ReturnToTour = 'returnToTour',
  NextFlow = 'nextFlow',
  FinishScreen = 'finishScreen',
}
